import { render, staticRenderFns } from "./WishListCount.vue?vue&type=template&id=0bcea93e&"
import script from "./WishListCount.vue?vue&type=script&lang=js&"
export * from "./WishListCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bcea93e')) {
      api.createRecord('0bcea93e', component.options)
    } else {
      api.reload('0bcea93e', component.options)
    }
    module.hot.accept("./WishListCount.vue?vue&type=template&id=0bcea93e&", function () {
      api.rerender('0bcea93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/wishList/WishListCount.vue"
export default component.exports